export default "__VITE_ASSET__VWpu0qPT__"